import "../superAdmin.css";
import React from "react";
import ButtonCom from "../../../components/button/button";

const Index = () => {
  return (
    <div className="admin-main">
      <div className="page-top-bar">
        <div>Data Backup And Restore</div>
        <ButtonCom
          type={"button"}
          class_name={"p_btn"}
          text={"Add"}
          url_or_onclick={null}
          icon={null}
          width={""}
        />
      </div>

      <div className="page-body" style={{marginTop: "-7px"}}>
        <div className="empty-content">
        <h3>Coming Soon</h3>
        </div>
      </div>
    </div>
  );
};

export default Index;
